import { createFileRoute } from '@tanstack/react-router';
import { sponsoredQuery } from '@/features/sponsored/api';
import { SponsoredFormPage } from '@/features/sponsored/pages/SponsoredFormPage';

export const Route = createFileRoute('/_authed/ops/sponsored/$id')({
  staticData: { help: 'sponsored' },
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(sponsoredQuery());
  },
  component: EditSponsored,
});

function EditSponsored() {
  const { id } = Route.useParams();
  return <SponsoredFormPage key={id} id={id} />;
}
